import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-br from-brand-charcoal via-brand-deep-purple to-brand-charcoal relative overflow-hidden" data-id="element-92">
      {/* Bold Arc Motif */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] opacity-10 pointer-events-none" data-id="element-93">
        <svg viewBox="0 0 400 400" fill="none" className="w-full h-full" data-id="element-94">
          <defs data-id="element-95">
            <linearGradient id="ctaGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-96">
              <stop offset="0%" stopColor="var(--colour-teal)" data-id="element-97" />
              <stop offset="50%" stopColor="var(--colour-magenta)" data-id="element-98" />
              <stop offset="100%" stopColor="var(--colour-orange)" data-id="element-99" />
            </linearGradient>
          </defs>
          <path d="M 200 40 A 160 160 0 0 1 360 200" stroke="url(#ctaGrad)" strokeWidth="40" strokeLinecap="round" data-id="element-100" />
          <path d="M 200 360 A 160 160 0 0 1 40 200" stroke="url(#ctaGrad)" strokeWidth="40" strokeLinecap="round" opacity="0.6" data-id="element-101" />
          <circle cx="200" cy="200" r="120" stroke="url(#ctaGrad)" strokeWidth="4" strokeDasharray="10 15" data-id="element-102" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-105">
            The issue on your mind right now — let's talk about it.
          </h2>

          <p className="text-xl md:text-2xl text-white/90 mb-4 leading-relaxed max-w-2xl mx-auto font-normal" data-id="element-106">
            Your enquiry is confidential. There is no obligation. If EquipMe is
            not the right fit, we will tell you.
          </p>

          <p className="text-white/70 mb-12 text-[15px] font-medium" data-id="element-107">
            We work with a limited number of organisations at any time to ensure
            quality and availability.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-108">
            <a href="#consultation" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-brand-magenta hover:bg-brand-plum text-white px-10 py-5 rounded-sm font-semibold transition-all shadow-2xl shadow-brand-magenta/40 hover:shadow-brand-magenta/60 text-center text-lg" data-id="element-109">
              <Phone size={20} data-id="element-110" />
              Book a confidential consultation
            </a>
            <a href="mailto:info@equipme-coachconsult.com" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-transparent border-2 border-brand-teal hover:bg-brand-teal/10 text-white px-10 py-5 rounded-sm font-semibold transition-all text-center text-lg" data-id="element-111">
              <Mail size={20} data-id="element-112" />
              Send a confidential enquiry
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 text-[15px] text-white/90 font-medium" data-id="element-113">
            <span className="flex items-center gap-2" data-id="element-114">
              <span className="w-2 h-2 rounded-full bg-brand-teal" data-id="element-115"></span>
              Typically responds within 24 hours
            </span>
            <span className="flex items-center gap-2" data-id="element-116">
              <span className="w-2 h-2 rounded-full bg-brand-magenta" data-id="element-117"></span>
              No obligation
            </span>
            <span className="flex items-center gap-2" data-id="element-118">
              <span className="w-2 h-2 rounded-full bg-brand-orange" data-id="element-119"></span>
              Fully confidential
            </span>
          </div>

          <div className="mt-12 pt-12 border-t border-white/20" data-id="element-120">
            <p className="text-white/80 text-[15px] italic font-normal mb-4" data-id="element-121">
              "Janet helped us navigate a complex cultural issue with
              sensitivity and practical wisdom. Her independence and discretion
              were invaluable."
            </p>
            <p className="text-white text-sm font-semibold uppercase tracking-wider mb-8" data-id="element-122">
              — Sarah Mitchell, Chief People Officer, Perth Resources Company
            </p>

            <p className="text-white/70 text-sm font-medium" data-id="element-123">
              Join organisations across Australia who chose independent support
              before issues escalated.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}